export default "__VITE_ASSET__Bzq5ACWo__"